export default "__VITE_ASSET__BWt7cwDw__"